import { useLayoutEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "./nav/BottomNavBar";
import DesktopLayout from "./desktop";
import LocationTracker from "../../lib/location-tracker";
import { useQuery } from "@tanstack/react-query";
import { useMyInfo } from "../../@apis/hooks/useAuth";
import { useLoginInfo } from "../../hooks/useLoginInfo";

const items = [
  {
    to: "/",
    label: "홈",
    img: {
      active: "/icons/ic-home.webp",
      inactive: "/icons/ic-home-de.webp",
      alt: "홈",
      size: 20,
    },
  },
  {
    to: "/competition",
    label: "대회접수",
    img: {
      active: "/icons/ic-competition-registration.webp",
      inactive: "/icons/ic-competition-registration-de.webp",
      alt: "대회접수",
      size: 20,
    },
  },
  {
    to: "/reservation",
    label: "골프장 예약",
    img: {
      active: "/icons/ic-reservation.webp",
      inactive: "/icons/ic-reservation-de.webp",
      alt: "골프장 예약",
      size: 20,
    },
  },
  {
    to: "/score",
    label: "스코어",
    img: {
      active: "/icons/ic-score-ac.webp",
      inactive: "/icons/ic-score-de.webp",
      alt: "스코어",
      size: 20,
    },
  },
  {
    to: "/community",
    label: "커뮤니티",
    img: {
      active: "/icons/ic-community.webp",
      inactive: "/icons/ic-community-de.webp",
      alt: "커뮤니티",
      size: 20,
    },
  },
  // {
  //   to: "/setting",
  //   label: "더보기",
  //   img: {
  //     active: "/icons/ic-more.webp",
  //     inactive: "/icons/ic-more-de.webp",
  //     alt: "더보기",
  //     size: 20,
  //   },
  // },
];

export default function Layout() {
  const mainRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    mainRef.current?.scrollTo(0, 0);
  }, [pathname]);

  const { isLoggedIn } = useLoginInfo();
  const { data: myInfoData } = useQuery({
    ...useMyInfo(),
    enabled: isLoggedIn,
  });
  const myInfo = isLoggedIn ? myInfoData?.data : undefined;
  const IS_PRODUCTION = import.meta.env.VITE_APP_MODE === "production";

  const allowedUsers = ["테스트1"];
  const filteredItems = items.filter((item) => {
    if (item.to !== "/reservation") return true;
    if (!IS_PRODUCTION) return true;
    if (!isLoggedIn || !myInfo) return false;
    return allowedUsers.includes(myInfo.name);
  });

  return (
    <div className="w-full min-h-dvh flex justify-center bg-[#f5f5f5] gap-[168px]">
      <DesktopLayout />
      <div
        className="
          w-full h-dvh bg-white flex flex-col relative
          max-w-[440px]
          shadow-[0px_30px_60px_0_rgba(0,0,0,0.1)]
        "
      >
        <main
          ref={mainRef}
          className="flex-1 overflow-y-auto overscroll-contain"
        >
          <LocationTracker />
          <Outlet />
        </main>
        <BottomNav items={filteredItems} />
      </div>
    </div>
  );
}
